import React from 'react';
import { Typography, TextField, FormControl, Dialog, Divider, Button, Box, } from '@mui/material';
import {
  FormStyled, DivSubmitButtons, DivFormTitle
} from '../../../Admin/Forms/styles';
import { WarningOutlined } from '@mui/icons-material';

interface IProps {
  onClose: CallableFunction;
  onSubmit: () => void;
  open: boolean;
}

const ModalDeleteAccountable = ({ open, onSubmit, onClose }: IProps) => {

  const handleSubmit = async () => {
    onSubmit();
    onClose();
  }

  return (
    <Dialog
      maxWidth='xs'
      fullWidth
      scroll='body'
      open={open}
      onClose={() => onClose()}
    >
      <FormStyled onSubmit={handleSubmit} style={styles.opacityContainer}>
        <DivFormTitle>
          <Typography variant='h6'>Excluir responsável</Typography>
        </DivFormTitle>
        <Divider />

        <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, margin: '20px 0'}}>
          <WarningOutlined />
          <Box sx={{width: '100%'}}>
            <Typography sx={{marginBottom: '20px'}}>
              Ao excluir este responsável, todos seus dados serão perdidos.
            </Typography>
            <Typography>
              Deseja prosseguir?
            </Typography>
          </Box>
        </Box>

        <Divider />
        <DivSubmitButtons>
          <Button sx={{color: '#D32F2F', marginRight: '10px' }} onClick={() => onClose()}>
            Cancelar
          </Button>
          <Button sx={{color: '#fff', background: '#4CAF50' }} onClick={() => handleSubmit()}>
            Excluir
          </Button>
        </DivSubmitButtons>
      </FormStyled>
    </Dialog>
  );
}

export default ModalDeleteAccountable;

const styles = {
  container: {
    padding: '10px',
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  print: {
    marginRight: 5,
  },
  contentContainer: {
    margin: '30px 0',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  opacityContainer: {
    position: 'relative'
  },
  fileError: {
    color: '#f44336'
  },
  question: {
    marginTop: 20,
  },
  sectionTitleContainer: {
    display: 'flex',
    marginTop: 20,
  },
  avatarContainer: {
    display: 'flex',
    padding: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatar: {
    width: 150,
    height: 150,
    marginTop: 20,
  },
  avatarButton: {
    margin: 5,
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  imageInput: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: 10,
  },
  buttonEditImage: {
    // margin: '-58px 0 0 -146px',
    margin: '10px 0',
  }
}
